<template>
    <b-container>

        <b-row class="m-0">
            <b-col class="p-0 roman fs-14 status-task" 
                   :class="item.StatusColor">

                <b-img :src="item.StatusImagePath" 
                       class="mr-10"/>

                {{item.StatusText}}
            </b-col>

            <b-col cols="2" class="p-0 date-string">
                {{item.MonthDateCreatedString}}
            </b-col>
        </b-row>

        <b-row class="m-0 task-text" 
               :class="item.IsActive ? 'active-text' : '' ">
               
            {{item.Text}}
        </b-row>

        <b-container v-if="item.IsActive" class="p-0">
            <hr class="my-4"/>
            
            <b-row class="m-0 bold fs-14">
                Категория
            </b-row>
            
            <b-row class="mb-20 roman fs-14">
                {{item.Category.FullName}}
            </b-row>
            
            <b-row class="m-0 bold fs-14">
            Плановая дата завершения
            </b-row>
            
            <b-row class="mb-20 roman fs-14">
                {{item.PlannedFinishDateString}}
            </b-row>

            <b-row class="m-0">
                <b-col class="p-0" lg="1">
                   <span class="avatar-letter">
                        {{item.AvatarLetter}}
                    </span>
                </b-col>

                <b-col class="p-0">                   

                    <b-row class="m-0 roman fs-14">                     
                        {{item.Creator.FullName}}
                    </b-row>

                    <b-row class="m-0 roman fs-14 gray">
                        {{item.MonthDateCreatedString}} 
                        {{item.HoursDateCreatedString}}
                    </b-row>
                </b-col>
            </b-row>

            <hr v-if="!item.IsCompleted && !isView" class="my-4"/>

            <b-row v-if="!item.IsCompleted && !isView"
                   class="m-0 row-button">

                <b-button variant="outline-primary" 
                          class="button-blue"
                          @click.stop="completeTask">

                    <font-awesome-icon icon="check"/>
                    Задача выполнена

                </b-button>
            </b-row>

        </b-container>

    </b-container>    

</template>

<script>
import '@/assets/styles/client/form/taskItem.css'

import apiService from'@/services/api.service'

export default {
    props: {
        item: {
            type: Object,
            default: null
        },
        isView: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        completeTask: function() {
            let todoDto = this.item.mapToDto();

            apiService.Client.TradePoints.TodoCategories.PostUpdate(this.$route.query.auditId, this.$route.query.id, todoDto)
                .then(response => {
                    this.$router.go(this.$router.currentRoute);
                })
                .catch(exception => {
                    console.log(exception);
                });
        }
    }
}
</script>